import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackIcon from '../../../assets/svg/backArrow.svg';
import { APP_LAYOUT_STYLES } from '../../../generic-components/Layout/constants';
import ContentWrapper from '../../../generic-components/ContentWrapper';
import ThreeColumnsContainer from '../../../generic-components/Layout/ThreeColumnsContainer';
import AppLayout from '../../../generic-components/Layout';
import EmergencyBucketBalance from '../components/EmergencyBucketBalance';
import EmergencyBucketAutoSaving from '../components/EmergencyBucketAutoSaving';
import UpperMessagePopUp from '../../transactions/components/UpperMessagePopUp';
import moneyMovementIcon from '../../../assets/icons/svg/colored-icons/ic-colored-success.svg';
import {
  PAGE_HEADERS, ADD_WITHDRAW_POPUP_TEXT, POPUP_LIFESPAN, SUB_PATHS, START_AUTO_SAVING_POPUP_TEXTS,
} from '../constants';
import EmergencyBucketLatestTransactions from '../components/EmergencyBucketLatestTransactions';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { FEATURE_FLAG } from '../../../constants/general';

const EmergencyBucketDashboard = () => {
  const { USER_BASIC, USER_PRO } = ADD_WITHDRAW_POPUP_TEXT;
  const { ADD_PATH, WITHDRAW_PATH, EMERGENCY_BUCKET_ACTIVATED } = SUB_PATHS;
  const { SAVINGS, EMERGENCY } = PAGE_HEADERS;
  const {
    SUCCESS_BASIC, SUCCESS_PRO, SUCCESS_CHANGED_1, SUCCESS_CHANGED_2,
  } = START_AUTO_SAVING_POPUP_TEXTS;
  const navigate = useNavigate();
  const params = useParams();
  const paramsArr = params.main?.split('-');
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const closePopup = () => {
    setShowPopup(false);
    window.history.replaceState(null, '', '/emergency-bucket-dashboard/:main');
  };

  const { t } = useTranslation();

  const getPopupMessage = () => {
    if (paramsArr && paramsArr.length > 0) {
      if (paramsArr[0] === WITHDRAW_PATH) {
        return `$${paramsArr[1]}${t(validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) ? USER_PRO.WITHDRAW : USER_BASIC.WITHDRAW)}`;
      }
      if (paramsArr[0] === ADD_PATH) {
        return `$${paramsArr[1]}${t(validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) ? USER_PRO.ADD : USER_BASIC.ADD)}`;
      }
      if (paramsArr.length === 4 && paramsArr[0] === EMERGENCY_BUCKET_ACTIVATED && paramsArr[3] && paramsArr[1] === 'true' && paramsArr[2] === 'false') {
        return `${t(SUCCESS_CHANGED_1)}${paramsArr[3]}${t(SUCCESS_CHANGED_2)}`;
      }
      if (paramsArr.length === 4 && paramsArr[0] === EMERGENCY_BUCKET_ACTIVATED && validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) && paramsArr[1] === 'true' && paramsArr[2] === 'true') {
        return t(SUCCESS_PRO);
      }
      if (paramsArr[0] === EMERGENCY_BUCKET_ACTIVATED && !validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) && paramsArr[1] === 'true') {
        return t(SUCCESS_BASIC);
      }
    }
    return '';
  };
  useEffect(() => {
    if (paramsArr && paramsArr.length > 0) {
      if (paramsArr[0] === WITHDRAW_PATH || paramsArr[0] === ADD_PATH || paramsArr[0] === EMERGENCY_BUCKET_ACTIVATED) {
        setShowPopup(true);
        setTimeout(() => {
          closePopup();
        }, POPUP_LIFESPAN);
      }
    }
  }, []);

  return (
    <AppLayout
      assetPath={BackIcon}
      title={validateFeatureFlag(FEATURE_FLAG.EMERGENCY_SAVING_ACCOUNT) ? t(SAVINGS) : t(EMERGENCY)}
      titleStyle='font-metricMedium text-bw08 text-xl ml-[1rem]'
      backButtonStyle='flex items-center justify-center w-[2rem] h-[2rem]'
      backDestination={0}
      layoutStyle={`${APP_LAYOUT_STYLES.LAYOUT} gap-0`}
      navBarStyle={`${APP_LAYOUT_STYLES.NAVBAR.HEADER_STYLE} mt-[1rem]`}
      handleNavigate={() => { navigate('/dashboard'); }}
    >
      {showPopup && paramsArr && paramsArr.length > 0 && <UpperMessagePopUp iconSource={moneyMovementIcon} handleClose={closePopup} messageText={getPopupMessage()} />}
      <ContentWrapper>
        <ThreeColumnsContainer
          firstColumnClassname='w-[28.5rem] max-h-[28rem] flex flex-col gap-4'
          firstColumnChildren={[<EmergencyBucketBalance />, <EmergencyBucketAutoSaving />]}
          secondColumnClassname='w-[22.5rem] max-h-[28rem] rounded-lg overflow-scroll'
          secondColumnChildren={[<EmergencyBucketLatestTransactions />]}
        />
      </ContentWrapper>
    </AppLayout>
  );
};

export default EmergencyBucketDashboard;
